export default {
  title: "ETS - Environment Total System By Luhott"
};
